<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  separator: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const formattedDate = computed(() => {
  const timestamp = props.separator.createdAt || props.separator.created_at;
  if (!timestamp) return '';
  return new Date(timestamp * 1000).toLocaleDateString();
});

const statusLabel = computed(() => {
  const status = props.separator.status;
  if (status === 'resolved') {
    return t('CONVERSATION.THREAD_SEPARATOR.RESOLVED', {
      date: formattedDate.value,
    });
  }
  return t('CONVERSATION.THREAD_SEPARATOR.STARTED', {
    date: formattedDate.value,
  });
});
</script>

<template>
  <li class="list-none flex justify-center py-3">
    <div
      class="px-3 py-1.5 text-xs font-medium rounded-full bg-n-alpha-2 text-n-slate-11 border border-n-weak"
    >
      {{ statusLabel }}
    </div>
  </li>
</template>
